import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header3";
import Footer from "../layout/footer4";
// Sliders
import {
  projectContent1,
  getHomeSliderContent3,
} from "../element/SliderContent";
import ProjectSlider1 from "../element/projectSlider1";
import HomeSlider from "../element/homeslider1";
import ScrollToTop from "../element/scrollToTop";
// Çoklu dil desteği
import { useLanguage } from "../../hooks/useLanguage";

// import '../../css/skin/skin-2.min.css';

const bg = require("../../images/background/map-bg.png");

const ServicesBar = () => {
  const { content } = useLanguage();
  const [service, setService] = useState(content.services);
  
  useEffect(() => {
    // Mevcut dildeki hizmetleri yükle
    setService(content.services);
  }, [content]);

  return (
    <>
      <div className="section-full bg-gray content-inner">
        <div className="container">
          <div className="section-head text-center">
            <h2 className="title">{content.texts.ourServices}</h2>
          </div>
          <div className="section-content row">
             {service.map((item) => (
    <div
        className="col-md-6 col-lg-4 col-sm-12 service-box style3 wow fadeInUp"
        data-wow-duration="2s"
        data-wow-delay="0.2s"
        key={item.ID}
        style={{ display: 'flex', marginBottom: '30px' }}
    >
        <div className="icon-bx-wraper" data-name={item.OrderNo} style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          height: '100%', 
          width: '100%',
          padding: '30px',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          transition: 'transform 0.3s ease'
        }}>
            <div className="icon-lg" style={{ marginBottom: '20px' }}>
                <Link to="#" className="icon-cell" >
                    <i className={item.IconName} ></i>
                </Link>
            </div>
            <div className="icon-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h2 className="dlab-tilte" style={{ marginBottom: '15px', fontSize: '18px', fontWeight: 'bold' }}>{item.ServiceName}</h2>
                <p style={{ flex: 1, margin: 0, lineHeight: '1.6' }}>{item.ServiceContent}</p>
            </div>
        </div>
    </div>
))}
            
          </div>
        </div>
      </div>
    </>
  );
};

// Ana sayfa içeriği komponenti (çoklu dil desteği için)
const Index3Content = () => {
  const { content } = useLanguage();
  
  return (
    <div className="section-full content-inner bg-white">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-lg-6 col-md-6 m-b30 wow fadeInUp"
            data-wow-duration="2s"
            data-wow-delay="0.3s"
          >
            <div className="our-story">
              <h2 className="title">
                {content.companyInfo.tagline.split(' ').slice(0, 2).join(' ')}
                <br /> <span className="text-primary">{content.companyInfo.tagline.split(' ').slice(2).join(' ')}</span>
              </h2>
              <h4 className="title">
                {content.companyInfo.description}
              </h4>
              <Link to="/about" className="site-button btnhover14">
                {content.texts.readMore}
              </Link>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-6 m-b30 wow fadeInUp"
            data-wow-duration="2s"
            data-wow-delay="0.6s"
          >
            <img
              src={require("../../images/about/about-1.jpg")}
              className="radius-sm"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Projeler bölümü (çoklu dil desteği ile)
const Index3Projects = () => {
  const { content } = useLanguage();
  
  return (
    <div
      className="section-full content-inner-2 bg-gray wow fadeInUp"
      data-wow-duration="2s"
      data-wow-delay="0.4s"
    >
      <div className="container">
        <div className="section-head text-center">
          <h2 className="title">{content.menu.portfolio}</h2>
        </div>
        <ProjectSlider1 data={projectContent1} />
      </div>
    </div>
  );
};


// Ana sayfa komponenti (çok dilli slider desteği ile)
const Index3 = () => {
  const { content } = useLanguage();
  
  return (
    <>
      <Header />

      <HomeSlider
        data={getHomeSliderContent3(content)}
        contentWrapperCls="sliderStyle3"
        hideBtn
      />

      <div className="page-content bg-white">
        <div className="content-block">
          <ServicesBar />
          <Index3Content />

          <Index3Projects />
        </div>
      </div>

      <Footer />
      <ScrollToTop />
    </>
  );
};

export default Index3;